import { NO_MATCH, NEGATIVE_MATCH, POSITIVE_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkSemanticType(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.hasType) {
    return NO_MATCH;
  }

  if (node.type === "operatorSymbol" && node.semanticTypes) {
    if (node.semanticTypes.some((t) => nodeCondition.hasType?.includes(`not:${node.type}:${t}`))) {
      return NEGATIVE_MATCH;
    }
    if (node.semanticTypes.some((t) => nodeCondition.hasType?.includes(`${node.type}:${t}`))) {
      return POSITIVE_MATCH;
    }
  }

  return NO_MATCH;
}
